module.exports = __webpack_public_path__ + "img/partner.28fa136e.png";